import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { SvgShieldIcon } from '@kiper/ui';
import { useFacialRegistrationContext } from '../../../../../../store/FacialRegistration';
import StepLayout from './StepLayout';
import useBinaryRain from './hooks/useBinaryRain';
import * as S from './styles';

const StepSubmitting = () => {
  const [t] = useTranslation('personalized-invite');
  const theme = useTheme();
  const { capturedImage, primaryColor } = useFacialRegistrationContext();

  const canvasRef = useBinaryRain({
    color: theme.colors.blackShades(0.9),
    fadeOpacity: 0.04,
  });

  const footer = (
    <S.WrapperFooter>
      <S.LoadingBar color={primaryColor} />
    </S.WrapperFooter>
  );

  return (
    <StepLayout emptyTitle footer={footer}>
      <S.StepTitle>{t('facial-registration.submitting.title')}</S.StepTitle>
      <S.StepDescription>
        {t('facial-registration.submitting.description')}
      </S.StepDescription>

      <S.SubmittingWrapper>
        <S.BinaryRainCanvas ref={canvasRef} />
        <S.AvatarWrapper>
          {capturedImage && (
            <S.FaceCaptureImage src={capturedImage} alt="Avatar" />
          )}

          <S.ShieldLockBadge>
            <SvgShieldIcon size={28} />
          </S.ShieldLockBadge>
        </S.AvatarWrapper>
      </S.SubmittingWrapper>
    </StepLayout>
  );
};

export default StepSubmitting;
